import { create } from 'zustand';

interface OperationFilterState {
  // Country/Marketplace filters
  marketplaceFilter: string[];
  
  // Search query
  searchQuery: string;
  
  // Additional filters
  filters: {
    city?: string;
    area?: string;
    distributionCenterId?: number;
    marketPlaceType?: string;
    customerEmail?: string;
    orderDateFrom?: string;
    orderDateTo?: string;
  };
  
  // Actions
  toggleMarketplace: (marketplace: string) => void;
  setSearchQuery: (query: string) => void;
  setFilters: (filters: Partial<OperationFilterState['filters']>) => void;
  clearAllFilters: () => void;
}

export const useOperationFilterStore = create<OperationFilterState>((set, get) => ({
  // Initial state
  marketplaceFilter: [],
  searchQuery: '',
  filters: {},
  
  // Actions
  toggleMarketplace: (marketplace: string) => {
    const { marketplaceFilter } = get();
    const newFilter = marketplaceFilter.includes(marketplace)
      ? marketplaceFilter.filter(m => m !== marketplace)
      : [...marketplaceFilter, marketplace];
    
    set({ marketplaceFilter: newFilter });
  },
  
  setSearchQuery: (query: string) => {
    set({ searchQuery: query });
  },
  
  setFilters: (newFilters: Partial<OperationFilterState['filters']>) => {
    const { filters } = get();
    set({ filters: { ...filters, ...newFilters } });
  },
  
  clearAllFilters: () => {
    set({
      marketplaceFilter: [],
      searchQuery: '',
      filters: {}
    });
  }
}));
